module.exports = {
    header: {
        dates: {
            date: 'SEPTEMBER 2025',
            place: 'MOSCOW VNUKOVO-3',
        },
        slogan: `
      Don’t miss<br/>
      the key event in the<br/>
      business aviation world <span>rubae</span>
    `,
        button: 'Become an Exhibitor',
        registrationButton: 'Buy a Ticket',
        saleMessage: {
            header: 'SAVE THE DATE!',
            message:
                'DO NOT MISS 15% EARLY BIRD DISCOUNT ON EXHIBITION SPACE BOOKING',
        },
        countDown: {
            text: 'UNTIL START',
            day: ' d.',
            cancelText: 'September 2025',
        },
    },
    about: {
        visitors: 'Key Industry Companies',
        exhibitors: 'Exhibitors',
        aircrafts: 'For Sponsors',
        conference: 'Main Program',
        about: 'Learn More About the Exhibition',
        marketing: 'Marketing Opportunities',
        navigation: {
            exhibitors: {
                title: 'For Exhibitors',
                description: `Become an exhibitor and gain maximum exposure by showcasing your company at this unique industry event in Russia and the CIS.`,
            },
            attendee: {
                title: 'For Visitors',
                description: `Stay informed about the latest industry trends and grow your business with RUBAE.`,
            },
            opportunities: {
                title: 'Additional Opportunities',
                description: `Make your time at the exhibition more convenient and efficient.`,
            },
            registration: {
                title: ' ',
                description: `Aircraft registration with Bermuda.`,
            },
        },
    },
    exhibitors: {
        exhibitors: {
            title: 'Exhibitors',
            buttonTitle: 'Become an Exhibitor',
            text: 'Applications are now open for participation in RUBAE 2025.',
            links: {
                'exhibitor-manual': 'Exhibitor Manual',
                'pages/general-contractor': 'General Contractor',
                'pages/freight-forwarder': 'Official Freight Forwarder',
                'pages/catering-partner': 'Official Catering Partner',
                'pages/visa-support': 'Visa Support',
            },
            personalAccountButton: 'Login to Personal Account',
        },
        attendee: {
            title: 'Visitors',
            buttonTitle: 'Buy a Ticket',
            text:
                'The Vnukovo-3 Business Aviation Center invites you to attend the only business aviation event in Russia and the CIS from September 10 to 11, 2025.',
            links: {
                'pages/about': 'General Information',
                'pages/location': 'Location',
                'pages/exhibitor-list': 'List of Exhibitors',
                pavilion_exposition: 'Exhibition Layout',
            },
        },
    },
    sponsors: 'Partners',
    participants: 'With the Participation of',
    'info-sponsors': 'Media Partners',
    advertisement: 'Other Advertising',
    contacts: {
        title: 'Contact Us',
        legalInfo: 'Legal Information',
        confidention: 'Privacy Policy',
    },
    contactForm: {
        name: 'Company Name',
        contactPerson: 'Contact Person',
        tel: 'Phone',
        email: 'E-mail',
        address: 'Address',
        website: 'Website',
        promo: 'Promo Code',
        boothNumber: 'Booth Number',
        stand: 'Stand',
        static: 'Static Display',
        submit: 'Submit',
        formatLabel: 'Participation Format',
        successMessage: 'Thank you! We will contact you shortly.',
        errorMessage: 'Something went wrong. Please try again later.',
    },
    conferenceProgramForm: {
        formTitle: 'Business Program Application',
        name: 'Full Name',
        company: 'Company',
        email: 'E-mail',
        subject: 'Presentation Topic',
        submit: 'Submit',
        successMessage: 'Thank you! We will contact you shortly.',
        errorMessage: 'Something went wrong. Please try again later.',
    },
    exhibitApplication: {
        applicationTypeButton: 'Select Placement Type',
        valuePlaceholder: 'Enter Value',
        services: {
            shellScheme: {
                title: 'Shell Scheme (min. 6㎡)',
                description:
                    'SHELL SCHEME includes: exhibition space, wall panels, carpet, 1 power socket, 1 table, 2 chairs, 1 lamp, fascia panel, liability insurance, company listing in the official RUBAE catalogue. Stand construction is carried out by the RUBAE General Contractor.',
            },
            spaceOnly: {
                title: 'Space Only (min. 18㎡)',
                description:
                    'SPACE ONLY includes: liability insurance, company listing in the official RUBAE catalogue. Stand construction and design must follow the exhibitor manual requirements.',
            },
            staticDisplayChalet3: {
                title: 'Chalet at Static Display Area (3×3)',
                description:
                    'CHALET includes: company name above the entrance, 1 power socket, carpet.',
            },
            staticDisplayChalet6: {
                title: 'Chalet at Static Display Area (6×6)',
                description:
                    'CHALET includes: company name above the entrance, 1 power socket, carpet.',
            },
            brokerProject: {
                title: 'Broker Project',
                description:
                    'WORKING DESK includes: carpeting, 1 electrical socket, 1 branded desk, 1 chair, 1 banner (1.0 x 2.5 meters), liability insurance, company listing in the official RUBAE catalogue, access to the broker lounge. Stand construction is carried out by the RUBAE General Contractor.',
            },
            firstTimeExhibitor: {
                title: 'First Time Exhibitor',
                description:
                    'WORKING PLACE includes: carpeting, 1 socket (up to 1kW), 1 logo, 2 chairs, 1 panel (1.0 x 2.5m) with full-color printing, company description in the RUBAE catalogue, 4 badges. Stand construction is carried out by the RUBAE General Contractor.',
            },
            upperDeck: {
                title: 'Second Floor (Double Storey - Space Only)',
            },
            wallBrandingChalet3: {
                title: 'Wall Branding (Chalet 3×3)',
            },
            wallBrandingChalet5: {
                title: 'Wall Branding (Chalet 6×6)',
            },
            catalogueAdPage05: {
                title: '1/2 Page, Full Color',
            },
            catalogueAdPage1: {
                title: '1/1 Page, Full Color',
            },
            staticDisplay: {
                title: 'Static Display Area',
                description: 'Static Display Area',
                length: 'Aircraft Length',
                wingspan: 'Wingspan',
            },
        },
        units: {
            sqrm: '㎡',
            unit: 'pcs',
            m: 'm',
        },
        addButton: 'Add Placement',
        catalogueAd: 'Advertising in the Official Catalogue',
        total: 'Total from',
        formTitle: 'Application for Participation',
        contactsTitle: 'Contacts',
        contactsSubtitle: '(all fields are required)',
        allocationTitle: 'Placement',
        comment:
            'This application serves as a basis for concluding a contract and issuing an invoice, which must be paid 50% within 10 days after issuance. The 50% advance must be paid by July 31, 2023. Please note that the 50% prepayment is non-refundable in case of cancellation.',
    },
    pages: {
        schedule: {
            about: 'General Information',
            registration: 'Registration',
            preview: 'Preview',
            schedule: 'Program',
            scheduleLink: 'Download the RUBAE Conference Program',
        },
        exhibitors: {
            filterDefault: 'Category',
            filterAll: 'All',
        },
    },
    gallery: 'Photo Gallery',
    scheduleWidget: {
        dates: 'September 2025',
        address: 'Vnukovo-3 Business Aviation Center, Moscow, Russia',
        date1: 'Wednesday, September 10',
        date2: 'Thursday, September 11',
        covid19: 'COVID-19 Safety Guidelines',
        covid19Link: '/files/COVID-19_eng.pdf',
    },
};



// WEBPACK FOOTER //
// ./src/data/messages/en.js